module.exports = __webpack_public_path__ + "static/media/download-gray-icon.55b2fa66.svg";